<template>
    <div>
         <v-row>
             <v-col cols="12" sm="6" md="4">
                 <Link  class="h-100" :href="route('bank_accounts.manage')">
                     <v-card class="h-100">
                         <v-card-text class="h-100 justify-center align-center d-flex">
                             <mdi-icon size="15">add_circle</mdi-icon>
                         </v-card-text>
                     </v-card>
                 </Link>
             </v-col>
             <v-col cols="12" sm="6" md="4" v-for="item in page.props.data?.bank_accounts">
                 <v-card class="h-100">
                    <v-card-title>
                         <div class="d-flex ga-2">
                            <div class="flex-none">
                                <mdi-icon>account_balance</mdi-icon>
                            </div>
                            <div class="flex-grow-1 min-w-0 text-truncate">{{ item.nickname }}</div>
                            <div class="flex-none">
                                <Link :href="route('bank_accounts.manage', item.id)">
                                    <v-btn-icon-text type="button" color="primary" density="compact">
                                        <mdi-icon>edit_square</mdi-icon>
                                    </v-btn-icon-text>
                                </Link>
                            </div>
                         </div>
                     </v-card-title>
                     <v-card-text>
                         <div class="fs-1 pt-2">
                            <div><span class="fw-medium">Bank:</span> {{ item.bank_name }}</div>
                            <div><span class="fw-medium">Account name:</span> {{ item.account_name }}</div>
                            <div><span class="fw-medium">Account number:</span> {{ item.account_number }}</div>
                            <div><span class="fw-medium">Routing number:</span> {{ item.routing_number }}</div>
                            <div><span class="fw-medium">Swift code:</span> {{ item.swift_code }}</div>
                            <div v-if="item.automate_transaction && item.additional_data?.is_meow" class="pt-2">
                                <span class="fw-bold text-success">Using Meow</span>
                                
                            </div>
                         </div>
                     </v-card-text>
                     
                 </v-card>
             </v-col>
         </v-row>
    </div>
 </template>
 <script setup lang="ts">
     import { ref } from "vue";
     import { usePage, Link, useForm } from '@inertiajs/vue3';
     import { SharedPage, SharedPageProps } from '@/Types/inertia';
     import { pageTitle, containerGapForForm } from '@/Composables/PageMeta';
     import { BankAccount } from "@/Types/Models/bank-account";
 
     pageTitle.value = 'Bank Accounts';
     containerGapForForm();
     interface PageData extends SharedPageProps{
         data?:{
             bank_accounts?: BankAccount[],
         }
     }
     const page = usePage<PageData>();
 </script>